import { gql } from '@apollo/client';

export const UPDATE_TITLE_WRITER = gql`
  mutation updateWriterTitle($id: String!, $writerId: String!) {
    updateWriterTitle(id: $id, writerId: $writerId) {
      id
      title
      writerId
      status
    }
  }
`;

export const UPDATE_TITLE_STATUS = gql`
  mutation updateStatusTitle($id: String!, $status: Int!) {
    updateStatusTitle(id: $id, input: { status: $status }) {
      id
      title
      writerId
      status
    }
  }
`;

export const GET_TITLE_CONTENT_BY_ID = gql`
  query titleContent($id: String!, $inReview: Boolean) {
    titleContent(id: $id, inReview: $inReview) {
      dynamicFields
      permissions {
        showSendToRevisionButton
        showPublishButton
        showSiteDomain
        showTag
        showPermalink
        showFeaturedImageLink
        canEdit
        showBrandsContents
        showProductsContents
        showDynamicFields
        showPostUrl
        showTagsFilter
        showSmallSeoToolsReport
        showProductType
        validations
      }
      titles {
        id
        contentId
        siteDomain
        title
        niche
        contentManagerId
        writerId
        editorId
        status
        reason
        otherReason
        comments
        premise
        publishPost
        postUrl
        createdAt
        researchLinks
        focusKeyword
        suggestedKeywords
        usedKeywords
        categories
        countries
        statusAtWP
        content
        titleContent
        featuredImage
        tag
        permalink
        smallSeoToolsReport
        createdBy
        backDate
        pagination
        brandId
        productId
        slug
        articleType
        inReview
        language
        deadline
        titlesToPresell
        productTypeId
      }
    }
  }
`;

export const GET_TITLES_AS_CONTENTMANAGER = gql`
  query titlesAsContentManager(
    $tag: String
    $limit: Int
    $offset: Int
    $dateStart: DateTime
    $dateEnd: DateTime
    $sites: [String!]
    $status: Int
    $writer: String
    $searchText: String
    $accountManagerEmail: String
    $byPublishPost: Boolean
    $language: String
  ) {
    titlesAsContentManager(
      filter: {
        tag: $tag
        limit: $limit
        offset: $offset
        dateStart: $dateStart
        dateEnd: $dateEnd
        sites: $sites
        status: $status
        writer: $writer
        searchText: $searchText
        accountManagerEmail: $accountManagerEmail
        byPublishPost: $byPublishPost
        language: $language
      }
    ) {
      total
      permissions {
        showPagination
        showWriters
        showStatus
        showBackDate
        showPublishNow
        showCountries
        showAddCategories
        statusToRejectReason
        reasonToOtherReason
        showSitesFilter
        showWritersFilter
        showAccountManagerFilter
        showBrandsTitles
        showProductsTitles
        showTransferSiteDomain
        showTagsFilter
        validations
        showProductType
        showLanguagesFilter
      }
      titles {
        id
        siteDomain
        title
        titleContent
        content
        contentManagerId
        accountManager {
          email
          name
        }
        writerId
        editorId
        status
        reason
        comments
        publishPost
        postUrl
        createdAt
        createdBy
        researchLinks
        suggestedKeywords
        categories
        countries
        statusAtWP
        tag
        niche
        otherReason
        brandId
        productId
        language
        deadline
        titlesToPresell
        originalTitleId
      }
    }
  }
`;

export const ADD_TITLE_BY_CONTENTMANAGER_ID = gql`
  mutation createTitleAsContentManager(
    $siteDomain: String!
    $title: String!
    $niche: String
    $contentManagerId: String!
    $writerId: String
    $status: Int!
    $reason: Int
    $comments: String
    $researchLinks: String
    $focusKeyword: String
    $suggestedKeywords: String
    $publishPost: DateTime
    $postUrl: String
    $categories: [String!]
    $tag: String
    $countries: [String!]
    $otherReason: String
    $backDate: Int!
    $pagination: Boolean!
    $brandId: String
    $productId: String
    $articleType: String
    $language: String
    $deadline: DateTime
    $titlesToPresell: [String!]
    $productTypeId: String
    $premise: String
  ) {
    createTitleAsContentManager(
      input: {
        siteDomain: $siteDomain
        title: $title
        niche: $niche
        contentManagerId: $contentManagerId
        writerId: $writerId
        status: $status
        reason: $reason
        comments: $comments
        researchLinks: $researchLinks
        focusKeyword: $focusKeyword
        suggestedKeywords: $suggestedKeywords
        publishPost: $publishPost
        postUrl: $postUrl
        categories: $categories
        tag: $tag
        countries: $countries
        otherReason: $otherReason
        backDate: $backDate
        pagination: $pagination
        brandId: $brandId
        productId: $productId
        articleType: $articleType
        language: $language
        deadline: $deadline
        titlesToPresell: $titlesToPresell
        productTypeId: $productTypeId
        premise: $premise
      }
    ) {
      id
      siteDomain
      title
      contentManagerId
      writerId
      status
      reason
      comments
      createdAt
      backDate
      brandId
      productId
    }
  }
`;

export const EDIT_TITLE_BY_CONTENTMANAGER_ID = gql`
  mutation updateTitleAsContentManager(
    $id: String!
    $siteDomain: String!
    $title: String!
    $niche: String
    $contentManagerId: String!
    $writerId: String
    $status: Int!
    $reason: Int
    $comments: String
    $postUrl: String
    $researchLinks: String
    $focusKeyword: String
    $suggestedKeywords: String
    $publishPost: DateTime
    $categories: [String!]
    $tag: String
    $countries: [String!]
    $otherReason: String
    $backDate: Int!
    $pagination: Boolean!
    $brandId: String
    $productId: String
    $articleType: String
    $language: String
    $deadline: DateTime
    $titlesToPresell: [String!]
    $productTypeId: String
    $premise: String
  ) {
    updateTitleAsContentManager(
      id: $id
      input: {
        siteDomain: $siteDomain
        title: $title
        niche: $niche
        contentManagerId: $contentManagerId
        writerId: $writerId
        status: $status
        reason: $reason
        comments: $comments
        postUrl: $postUrl
        researchLinks: $researchLinks
        focusKeyword: $focusKeyword
        suggestedKeywords: $suggestedKeywords
        publishPost: $publishPost
        categories: $categories
        tag: $tag
        countries: $countries
        otherReason: $otherReason
        backDate: $backDate
        pagination: $pagination
        brandId: $brandId
        productId: $productId
        articleType: $articleType
        language: $language
        deadline: $deadline
        titlesToPresell: $titlesToPresell
        productTypeId: $productTypeId
        premise: $premise
      }
    ) {
      id
      siteDomain
      title
      contentManagerId
      writerId
      status
      reason
      comments
      createdAt
      backDate
      brandId
      productId
    }
  }
`;

export const DELETE_TITLE = gql`
  mutation deleteTitle($id: String!) {
    deleteTitle(id: $id) {
      id
    }
  }
`;

export const UPDATE_TITLE_PRIORITY = gql`
  mutation updateTitlePriority($titleId: String!, $titleIdReplaced: String!) {
    updateTitlePriority(titleId: $titleId, titleIdReplaced: $titleIdReplaced) {
      id
      title
      priority
    }
  }
`;

export const TRANSFER_TITLE_SITE_DOMAIN = gql`
  mutation transferSiteDomain(
    $titleId: String!
    $siteDomainDestination: String!
  ) {
    transferSiteDomain(
      titleId: $titleId
      siteDomainDestination: $siteDomainDestination
    ) {
      id
      siteDomain
    }
  }
`;

export const UPDATE_TITLE_PAGINATION = gql`
  mutation updatePaginationTitle($id: String!, $pagination: Boolean!) {
    updatePaginationTitle(id: $id, pagination: $pagination) {
      id
    }
  }
`;

export const GET_CONTENT_HISTORY = gql`
  query contentHistories($titleId: String!) {
    contentHistories(titleId: $titleId) {
      totalTimeToReviewInSec
      histories {
        user {
          name
          email
          role
        }
        duration
        currentTitleStatus
        previousTitleStatus
        createdAt
        updatedAt
      }
    }
  }
`;

export const PAUSE_REVIEW = gql`
  mutation pauseReview($titleId: String!) {
    pauseReview(titleId: $titleId)
  }
`;

export const TRANSLATE_TITLE = gql`
  mutation translateTitle($id: String!, $codes: [String!]!) {
    translateTitle(id: $id, codes: $codes)
  }
`;

export const TRY_TRANSLATING_THE_TITLE_AGAIN = gql`
  mutation tryTranslatingTheTitleAgain($id: String!) {
    tryTranslatingTheTitleAgain(id: $id)
  }
`;

export const IMPORT_URLS = gql`
  mutation importPostsFromWordpress($urls: String!) {
    importPostsFromWordpress(urls: $urls)
  }
`;

export const CATEGORIZE_TITLES = gql`
  mutation categorizeTitles($originalTitleId: String!) {
    categorizeTitles(originalTitleId: $originalTitleId)
  }
`;

export const TITLE_HAS_TRANSLATIONS = gql`
  query titleHasTranslations($id: String!) {
    titleHasTranslations(id: $id)
  }
`;

export const CONTENT_REPLICATOR = gql`
  mutation replicateContent(
    $siteId: String!
    $urls: [ReplicateContentUrlsInput!]!
  ) {
    replicateContent(siteId: $siteId, urls: $urls)
  }
`;

export const REPLICATE_CONTENT_BY_TITLE = gql`
  mutation replicateContentByTitle(
    $originalTitleId: String!
    $titlesIds: [String!]!
  ) {
    replicateContentByTitle(
      originalTitleId: $originalTitleId
      titlesIds: $titlesIds
    )
  }
`;

export const EXPAND_CONTENT_BY_TITLE = gql`
  mutation expandContentByTitle($titleId: String!) {
    expandContentByTitle(title: $title)
  }
`;
